export default [

     {
          path: '/automation-rule',
          name: 'AutomationRule',
          component: () => import("@/views/Page/AutomationRule/AutomationRule.vue"),
           meta: {
               title: 'AutomationRule',
          },
     }
];